import { render, staticRenderFns } from "./org_update.vue?vue&type=template&id=48d22dc4"
import script from "./org_update.vue?vue&type=script&lang=js"
export * from "./org_update.vue?vue&type=script&lang=js"
import style0 from "./org_update.vue?vue&type=style&index=0&id=48d22dc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports